export default {
    /************************/
    //  Messages
    /************************/

    LOGIN_SUCCESS_MESSAGE: "Successfully logged in.",
    LOGOUT_SUCCESS_MESSAGE: "Successfully logged out.",
    PASSWORD_CHANGED_SUCCESSFULLY: "Password changed successfully, Please login with your new password.",
    SESSION_EXPIRED_MESSAGE: "Your session is expired.",
    PROMPT_LOGIN: "Please login.",
    FORBIDDEN_CONTENT: "Your dont have permission.",
    LOGIN_FAILED: "Login failed. Wrong email or password.",
    INTERNAL_SERVER_ERROR: "Server not responding, Please contact Admin.",
    COMMON_SAVE_MESSAGE: "Saved Successfully",
    USER_REGISTERED: "Registration successful; Password has been sent to the registered email.",
    COMMON_DELETE_MESSAGE: "Deleted Successfully",
    FORM_VALIDATION_ERROR: "There are items that require your attention.",
    FORM_REQUIRED_VALIDATION_ERROR: "Please fill all the required fields.",
    NO_RESULT_FOUND: "No result found",
    API_REQUEST_FAILED: "Request failed",
    RESET_PASSWORD_INVALID_URL: "Invalid Url, Please contact Admin.",
    //Form error
    MANDATORY_FIELD_ERROR: "This field is required.",
    INVALID_EMAIL: "Invalid email format.",
    INVALID_DATE: "Accepts only DD/MM/YYYY.",
    DATE_MIN_ERROR: "Date should be greater than ",
    DATE_MAX_ERROR: "Date should be less than ",
    INVALID_DATE_TIME: "Accepts only DD/MM/YYYY HH:MM.",
    INVALID_NUMBER_FIELD_ERROR: "This field accepts only numbers.",
    FILE_UPLOAD_SIZE_ERROR: "Individual file size should be less than 5 MB!",
    FILE_UPLOAD_FAILED: "File upload failed.",
    CUSTOM_MILEAGE_ERROR: "Mileage at date of Job must be greater than Last Recorded Mileage ",

    FINANCIAL_PERIOD_ERROR: "Please select a period from dropdown",

    JOB_ID_CREATION_FAILED: "Job Number creation failed",

    SERVICE_SCHEDULE_DUE_MISMATCH: "Due tolerance cannot be greater than Next Due.",
    SERVICE_SCHEDULE_FREQUENCY_DUE_MISMATCH: "Due tolerance cannot be greater than Service Due.",
    SERVICE_SCHEDULE_EMAIL_TRIGGER_ALERT: "This update will trigger notifications to Admin after saving Vehicle. Do you really want to update?",

    EMAIL_TRIGGER_ALERT: "Are you sure you want to trigger the email",
    EMAIL_TRIGGER_SUCCESS: "Email triggered successfully",
    EMAIL_TRIGGER_FAILED: "Email triggering failed",
    SUPPLIER_EMAIL_NOTFOUND: "Supplier doesn't have an email address",
    PASSWORD_MISMATCH: "Password & Confirm Password not matching",
    FORGOT_PASSWORD_INFO: "Password reset link will be sent to your registered email address.",
    FORGOT_PASSWORD_EMAIL_SUCCESS: "We have emailed your password reset link!",
    FORGOT_PASSWORD_EMAIL_FAILED: "We can't find a user with that email address.",
    FORGOT_PASSWORD_THROTTLED: "Please wait before retrying.",
    RESET_PASSWORD_FAILED: "Password reset failed.",

    CUSTOM_REPORT_SELECT_MODULE: "Please select the module.",
    CUSTOM_REPORT_APPLY_FILTERS: "Please select the query fields.",
    CUSTOM_REPORT_OUTPUT_FILTERS: "Please select the data output fields.",
    CUSTOM_REPORT_GENERATE_REPORT: "Please generate report to download."
}   